const conferenceArticleStyle = Object.freeze({});

export default conferenceArticleStyle;
